import CryptoJS from 'crypto-js'
import Resizer from 'react-image-file-resizer'
import { toast } from 'react-toastify'
import visa from '../assets/img/visa_img.png'
import master from '../assets/img/master_card.png'
import discover from '../assets/img/discover_card.png'
import diner from '../assets/img/diners_card.png'
import amex from '../assets/img/amax_card.png'
import jcb from '../assets/img/jcb_hr.png'
import blank from '../assets/img/blank_credit_card.png'
import masterimg from '../assets/img/master_img.png'
import parkingpayments from '../assets/img/parkingpayments.png'
import townsend from '../assets/img/townsend.png'
import jordanImage from '../assets/img/intrapark_blue1bg.png'
import logos from '../assets/img/logos.svg'
import moment from 'moment'
import { STORAGE_KEY } from '../../../constants'
import { getConfigDetails } from '../../../services/config'

/**
 * Common Utility for dynamic decimal formatting.
 * @param {string|number} value - The numerical value to format.
 * @param {number} decimals - Number of decimal places, default 3.
 * @returns {string} The formatted number as a string.
 */
export const formatDecimal = (value, decimals = 3) => {
  if (value === null || value === undefined || value === '') return (0).toFixed(decimals)
  const num = Number(value.toString().replace(/,/g, ''))
  return isNaN(num) ? (0).toFixed(decimals) : num.toFixed(decimals)
}

/**
 * Common Utility to safely check if a monetary amount is zero.
 * Overcomes static string comparisons like "0.00" === "0.00".
 * @param {string|number} value - The numerical value to check.
 * @returns {boolean} True if the value evaluates to 0.
 */
export const isZeroAmount = (value) => {
  if (value === null || value === undefined || value === '') return true
  const num = Number(value.toString().replace(/,/g, ''))
  return isNaN(num) || num === 0
}

export const getBearerToken = () => localStorage.getItem(STORAGE_KEY.ID_TOKEN)

export const restrictInputValues = (event) => {
  if (!`${event.target.value}${event.key}`.match(/^[0-9]{0,6}$/)) {
    // block the input if result does not match
    event.preventDefault()
    event.stopPropagation()
    return false
  }
}

export const validateEmail = (email) => {
  // eslint-disable-next-line no-useless-escape
  const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
  return pattern.test(email)
}

export function isLoggedIn() {
  const userDataFromStorage = localStorage.getItem('sign_in') ? localStorage.getItem('sign_in') : '{}'
  const userData = JSON.parse(userDataFromStorage)
  const access_token = userData?.access_token
  if (access_token && access_token != '') {
    return true
  } else {
    return false
  }
}

export function loggedInUserData() {
  const userData = JSON.parse(localStorage.getItem('sign_in') ? localStorage.getItem('sign_in') : localStorage.getItem('sign_up') ? localStorage.getItem('sign_up') : localStorage.getItem('userData') ? localStorage.getItem('userData') : '{}')
  return userData
}

export const restrictSpecialChar = (e) => {
  const result = (e.key == '!' || e.key == '@' || e.key == '#' || e.key == '$' || e.key == '%' || e.key == '^'
    || e.key == '&' || e.key == '~' || e.key == '`' || e.key == '*' || e.key == '(' || e.key == ')' || e.key == '_'
    || e.key == '=' || e.key == '+' || e.key == '[' || e.key == ']' || e.key == '{' || e.key == '}' || e.keyCode == 220
    || e.key == '|' || e.key == ':' || e.key == ';' || e.keyCode == 222 || e.key == ' ' || e.key == '?' || e.key == '.' || e.key == ',' || e.key == '>' || e.key == '<')
  if (result) {
    e.preventDefault()
  } else {
    return result
  }
}

export const fileChangedHandler = (event, fileId, setUpdateFileState, fileWidth, fileHeight) => {
  let fileInput = false
  let file = document.getElementById(fileId).files[0]
  fileInput = file && (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif')
  if (fileInput) {
    try {
      Resizer.imageFileResizer(
        file,
        fileWidth,
        fileHeight,
        'PNG', // fileType(JPEG, PNG,WEBP)
        100,  // quality compression(for jpeg)
        0, // rotation(0-100)
        (uri) => {
          new Promise((resolve, reject) => {
            const img = new Image()
            // the following handler will fire after a successful loading of the image
            img.onload = () => {
              const { naturalWidth: width, naturalHeight: height } = img
              resolve({ width, height })
              setUpdateFileState({ [fileId]: uri })
            }
            // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
            img.onerror = () => {
              reject('There was some problem with the image.')
            }
            img.src = URL.createObjectURL(uri)
          })
        },
        'file' // outputType( base64, blob or file)
      )
    } catch (err) {
      setUpdateFileState({ fileId: '' })
    }
  } else {
    setUpdateFileState({ fileId: '' })
  }
}

export const emailValidation = (value) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
}

export const encryptionHandler = (d) => {
  var nonceString = d.name_on_card + ':' + d.card_number + ':' + d.expiration_date + ':' + d.security_code + ':' + d.zip_code
  var CryptoJSAesJson = {
    stringify: function (cipherParams) {
      var j = {
        ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
        iv: '',
        s: ''
      }
      if (cipherParams.iv)
        j.iv = cipherParams.iv.toString()
      if (cipherParams.salt)
        j.s = cipherParams.salt.toString()
      return JSON.stringify(j)
    },
    parse: function (jsonStr) {
      var j = JSON.parse(jsonStr)
      var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
      if (j.iv)
        cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s)
        cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams
    }
  }
  var encrypted = CryptoJS.AES.encrypt(JSON.stringify(nonceString), getConfigDetails()?.chiperKey, { format: CryptoJSAesJson }).toString()
  return encrypted
}


// to identifiy the type of the licence number

export const IdentifyLicenseNumber = (licenseNumber) => {
  const license_number = licenseNumber?.toUpperCase()
  if (license_number?.length === 9) {
    const alpha = license_number?.slice(0, 1)
    const number = license_number?.slice(1, 9)
    if (/^[a-zA-Z]+$/.test(alpha) && !/^[a-zA-Z]+$/.test(number)) {
      return 'Resident'
    } else {
      return 'Non-resident'
    }
  } else if (license_number !== '' && license_number?.length >= 7) {
    return 'Non-resident'
  } else {
    return ''
  }
}

export const notify = (type, message) => {
  if (type === 'error') {
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT
    })
  } else if (type === 'success') {
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT
    })
  }
}

export const phoneMasker = (phone) => {

  if (phone && phone.length >= 10) {
    let strlen = phone.length
    let start = strlen - 10
    let result = phone.slice(start, strlen)
    var USNumber = result.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber = '(' + USNumber[1] + ') ' + USNumber[2] + '-' + USNumber[3]
  } else {
    return '-'
  }

}
export const messageExtendSuccessPayment = 'Thank you for Parking with Us. Your Parking has been extended and ticket is sent to the registered Mobile Number.'
export const messageSuccessPayment = 'Thank you for Parking with Us. Your e-Ticket details has been sent to the registered Mobile Number.'
export const errorMessagePaymentFailed = 'Something went wrong. Please check your network connection and try again in some time. If your card is already charged, then please contact our support team.'

export const TimeConversion = (timeDuration) => {
  const daystoHoursTotal = timeDuration?.days && timeDuration?.days.length == 0 ? timeDuration?.days[0] : timeDuration?.days
  const hoursTotal = timeDuration?.hours && timeDuration?.hours.length >= 0 ? timeDuration?.hours[0] : timeDuration?.hours
  const minutesTotal = timeDuration?.minutes && timeDuration?.minutes.length >= 0 ? timeDuration?.minutes[0] : timeDuration?.minutes < 10 ? '0' + timeDuration?.minutes : timeDuration?.minutes
  const daystoHours = Number(daystoHoursTotal) * 24
  const finalHours = Number(daystoHours) + Number(hoursTotal) + (Number(minutesTotal) / 60)
  return formatDecimal(finalHours)
}
//old function minutes
// export const TimeConversion = (timeDuration) => {
//   const daystoHours = Number(timeDuration?.days) * 24
//   const minutestoHours = Number(timeDuration?.minutes) / 60
//   const totalHours = Number(daystoHours) + Number(timeDuration?.hours) + Number(minutestoHours)
//   return totalHours ? totalHours : 0
// }

export const getFieldValue = (name, e) => {
  return { target: { name: name, value: e } }
}

export const getLocation = (faciltyData) => {
  const location = faciltyData?.geolocations
  return `https://www.google.com/maps?daddr=${location?.latitude},${location?.longitude}+(${faciltyData?.full_name?.replace(/ /g, '+')})`
}


export const getMobileOS = () => {
  const ua = navigator.userAgent
  if (/android/i.test(ua)) {
    return 'Android'
  }
  else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'iOS'
  }
  return 'Other'
}

export const getCardIcon = (type) => {

  const cardType = type?.toLowerCase()

  switch (cardType) {
    case 'visa':
      return visa
    case 'vs':
      return visa
    case 'mastercard':
      return master
    case 'mastercardpng':
      return masterimg
    case 'mc':
      return master
    case 'm/c':
      return master
    case 'discover':
      return discover
    case 'dinersclub':
      return diner
    case 'americanexpress':
      return amex
    case 'amex':
      return amex
    case 'jcb':
      return jcb
    default:
      return blank
  }
}


export const getPartnerLogo = (name) => {

  const patnerName = name?.toLowerCase()
  switch (patnerName) {

    case 'parkingpayments':
      return parkingpayments
    case 'townsend':
      return townsend
    case 'demoparkengage':
      return logos
    case 'intrapark':
      return jordanImage

    default:
      return logos
  }
}

export const getPartnerTagline = (name) => {

  const patnerName = name?.toLowerCase()
  switch (patnerName) {

    case 'parkingpayments':
      return 'Parking Payments'
    case 'townsend':
      return 'PCI Townsend Parking'
    case 'demoparkengage':
      return 'Parkengage Parking'
    case 'intrapark':
      return 'IntraPark Parking'
    default:
      return 'Parkengage Parking'
  }
}

export const isSessionNotActive = (days, hours, minutes, seconds) => {
  if (days == '00' && hours == '00' && minutes == '00' && seconds == '00') {
    return false
  } else {
    return true
  }
}

export const getBreakUpDetails = (paymentData) => {
  let listItem = []
  if (paymentData?.parking_amount && (!isZeroAmount(paymentData?.parking_amount) || paymentData?.is_price_applicable == '1')) {
    listItem = [...listItem, { 'headerName': 'Parking Amount', 'val': `$${formatDecimal(paymentData?.parking_amount)}` }]
  }

  if ((paymentData?.paid_amount && paymentData?.paid_amount !== '' && (!isZeroAmount(paymentData?.paid_amount)))) {
    listItem = [...listItem, { 'headerName': 'Validated Amount', 'val': paymentData?.paid_amount && !isZeroAmount(paymentData?.paid_amount) ? `(-) $${formatDecimal(paymentData?.paid_amount)}` : '$0.000' }]
  }

  // if (paymentData?.discount_amount != '' && paymentData?.discount_amount != null) {
  //   listItem = [...listItem, { 'headerName': 'Discount Amount', 'val': `$${paymentData?.discount_amount != '' ? paymentData?.discount_amount : '-'}` }]
  // }

  // if ((paymentData?.discount_hours && paymentData?.discount_hours != '') || (paymentData?.discount_amount && paymentData?.discount_amount != '' && Number(paymentData?.discount_amount) > 0)) {
  //   listItem = [...listItem, { 'headerName': paymentData?.discount_hours ? `Validated ${paymentData?.discount_hours} Hrs Free` : '-', 'val': `- $${paymentData?.discount_hours ? paymentData?.discount_hours : '-'}` }]
  // }

  // if (paymentData?.amount_paid && paymentData?.amount_paid !== '' && Number(paymentData?.amount_paid) > 0 && Number(paymentData?.payable_amount) > 0) {
  //   listItem = [...listItem, { 'headerName': 'Amount Paid', 'val': `- $${paymentData?.amount_paid ? Number(paymentData?.amount_paid)?.toFixed(2) : 0}` }]
  // }

  //comment because overstay not found in api its remove from api

  // if (paymentData?.overstay_amount && paymentData?.overstay_amount !== '' && paymentData?.overstay_amount != '0.00' && Number(paymentData?.overstay_amount) > 0) {
  //   listItem = [...listItem, { 'headerName': 'Overstay Amount', 'val': `$${paymentData?.overstay_amount ? Number(paymentData?.overstay_amount).toFixed(2) : 0}` }]
  // }

  if (paymentData?.extend_amount && paymentData?.extend_amount !== '' && ((!isZeroAmount(paymentData?.extend_amount)))) {
    listItem = [...listItem, { 'headerName': 'Extended Amount', 'val': `$${formatDecimal(paymentData?.extend_amount)}` }]
  }

  if ((paymentData?.discount_hours && paymentData?.discount_hours != '') || (paymentData?.discount_amount && paymentData?.discount_amount != '' && (!isZeroAmount(paymentData?.discount_amount))) || ((paymentData?.promocode_discount_hours && paymentData?.promocode_discount_hours != '') || (paymentData?.promocode_discount_amount && paymentData?.promocode_discount_amount != '' && (!isZeroAmount(paymentData?.promocode_discount_amount))))) {
    listItem = [...listItem, { 'headerName': (paymentData?.discount_hours || paymentData?.promocode_discount_hours) ? `Validated Amount (${paymentData?.discount_hours ? paymentData?.discount_hours : paymentData?.promocode_discount_hours} Hrs Free)` : 'Discount Amount', 'val': (paymentData?.discount_amount && !isZeroAmount(paymentData?.discount_amount)) ? `(-) $${formatDecimal(paymentData?.discount_amount)}` : (paymentData?.promocode_discount_amount && !isZeroAmount(paymentData?.promocode_discount_amount)) ? `(-) $${formatDecimal(paymentData?.promocode_discount_amount)}` : '$0.000' }]
  }

  if ((paymentData?.processing_fee && !isZeroAmount(paymentData?.processing_fee) && (paymentData?.is_overstay != 1 || paymentData?.is_extended != 1)) || paymentData?.is_price_applicable == '1') {
    listItem = [...listItem, { 'headerName': 'Processing Fee', 'val': `$${formatDecimal(paymentData?.processing_fee)}` }]
  }

  if (((paymentData?.tax_rate && !isZeroAmount(paymentData?.tax_rate)) || (paymentData?.tax_fee && !isZeroAmount(paymentData?.tax_fee))) || paymentData?.is_price_applicable == '1') {
    listItem = [...listItem, { 'headerName': 'Tax', 'val': `$${paymentData?.tax_rate ? formatDecimal(paymentData?.tax_rate) : formatDecimal(paymentData?.tax_fee)}` }]
  }


  return listItem

}

export const isPromoValidateButton = (facilityData, conditionArray) => {
  // Check if is_promocode_validation_enabled's value is in the conditionArray
  const isPromocodeValidationEnabled = facilityData?.facility?.is_promocode_validation_enabled
  if (isPromocodeValidationEnabled !== undefined && conditionArray.includes(isPromocodeValidationEnabled)) {
    return true
  } else {
    return false
  }
}

export const isExtendButton = (facilityData, conditionArray) => {
  // Check if is_extend_allow's value is in the conditionArray
  const isPromocodeValidationEnabled = facilityData?.is_extend_allow
  if (isPromocodeValidationEnabled !== undefined && conditionArray.includes(isPromocodeValidationEnabled)) {
    return true
  } else {
    return false
  }
}

export const priceGreaterOrNot = (ticketDetails) => {
  const paymentDataKeys = ['parking_amount', 'amount_paid', 'processing_fee', 'tax_rate', 'payable_amount', 'grand_total', 'discount_amount', 'paid_amount']
  let isGreaterOrNot = paymentDataKeys.map((key) => {
    if ((ticketDetails?.[key] && (Number(ticketDetails?.[key]) > 0 || ticketDetails?.is_price_applicable == '1'))) {
      return true
    } else {
      return false
    }
  })
  if (isGreaterOrNot.includes(true)) {
    return true
  } else {
    return false
  }
}


export const getHoursForRateBand = (data) => {
  return parseInt(data?.[0]?.max_stay)
}

export const getPartnerDetails = () => {
  const partner = localStorage.getItem('partnerData') ? JSON.parse(localStorage.getItem('partnerData')) : sessionStorage.getItem('partnerData') ? JSON.parse(sessionStorage.getItem('partnerData')) : ''
  return partner
}

export function sortPortalPermissionByKey(partnerDetails, sectionName) {
  return partnerDetails?.customer_portal_permission?.[sectionName]?.map((item) => item)
}

export const isPermissionExist = (data, itemName) => {
  const filterObj = (data?.length > 0) && data?.filter((item) => item?.display_name == itemName)
  if (filterObj[0]?.is_default == '1') {
    return true
  } else {
    return false
  }
}

export const getFormattedTime = (totalhours, isConvert) => {

  const splittedTime = totalhours?.split('.')
  let minutes
  if (isConvert) {
    minutes = (splittedTime?.[1] / 100) * 60
  } else {
    minutes = splittedTime?.[1]
  }
  const hours = splittedTime ? `${splittedTime?.[0] == 0 ? '00' : splittedTime?.[0] == 0 ? '00' : Number(splittedTime?.[0]) < 10 ? `0${splittedTime?.[0]} ` : splittedTime?.[0]} : ${minutes != 0 ? minutes : '00'}` : ''
  return hours
}

export const getDeviceType = () => {
  // Find if the device is IOS or Android/General
  let userAgent = navigator.userAgent || navigator.vendor
  const deviceType = (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    ? true : false
  return deviceType
}

export const getConvertedDate = (date) => {
  const deviceType = getDeviceType()
  let date_final

  const dateNew = moment(date, 'YYYY-MM-DD HH:mm:ss A').format('YYYY-MM-DD HH:mm:ss')
  if (deviceType) {
    let arr = dateNew.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final = newDate
  } else {
    date_final = dateNew
  }
  return date_final
}

export const getErrorMessage = (response) => {
  let errorMsg = 'Sorry! something went wrong, please try again.'
  const errorsList = response.errors
  if (errorsList.message !== 'Validation Errors') {
    errorMsg = errorsList.message
  } else {
    for (const key in errorsList.detail) {
      if (Object.prototype.hasOwnProperty.call(errorsList.detail, key)) {
        if (typeof errorsList.detail === 'undefined') {
          errorMsg = errorsList.message
        } else {
          errorMsg = Array.isArray(errorsList.detail[key]) ? errorsList.detail[key][0] : errorsList.detail[key]
        }
      }
    }
  }

  return errorMsg
}
export const convertNumDouble = (timer) => {
  if (!Number(timer).isNaN && (Number(timer) < 10 && Number(timer) > 0)) {
    return '0' + timer
  } else {
    return timer
  }
}
export const convertTimeToDoubleDig = (time) => {
  let stringTime = time + ''
  // console.log(time, stringTime, 'time')
  if (stringTime.includes('.')) {
    let str = stringTime.split('.')
    // console.log(str, 'time 2')
    if (Number(str[0]) < 9) {
      return '0' + str[0] + '.' + str[1]
    } else {
      return time
    }
  } else {
    return time
  }
}